(function($) {

    $(document).ready(function () {
        if ($('.office-map .map-office-wrap .map-block').length) {

            $('.office-map .offices-nav li').on('click', function() {
               var $this = $(this);
               var target = $this.data('target');

               $this.siblings().removeClass('active');
               $this.addClass('active');

               $('.office-map .map-office-wrap').removeClass('active');
               $('.office-map .map-office-wrap[data-target="'+ target +'"]').addClass('active');
            });

        }
    });

})( jQuery );